import React from "react";
import { Link } from "react-router-dom";

// Single source of truth for the "Orbis ERP" wordmark. Never wraps; mark + text sit on one baseline.
const TONE = { app: "bg-blue-500 text-white", platform: "bg-teal-500 text-slate-950", site: "site-bg-primary text-white", mobile: "bg-blue-600 text-white" };
const SIZE = { sm: ["h-7 w-7 rounded text-sm", "text-base"], md: ["h-8 w-8 rounded-lg text-base", "text-lg"], lg: ["h-12 w-12 rounded-2xl text-2xl", "text-2xl"] };

export function BrandLogo({ name = "Orbis ERP", tone = "app", size = "sm", to, letter, logoUrl, className = "", testId = "brand-logo" }) {
  const [mark, text] = SIZE[size] || SIZE.sm;
  const inner = <>
    {logoUrl ? <img src={logoUrl} alt="" className={`${mark.split(" ")[0]} w-auto max-w-[120px] object-contain shrink-0`} data-testid={`${testId}-img`} /> : <span className={`${mark} ${TONE[tone] || TONE.app} shrink-0 inline-flex items-center justify-center font-heading font-bold leading-none`} aria-hidden="true">{letter || name[0]}</span>}
    <span className={`font-heading font-semibold tracking-tight whitespace-nowrap leading-none ${text}`}>{name}</span>
  </>;
  const cls = `inline-flex items-center gap-2 shrink-0 self-start whitespace-nowrap ${className}`;
  return to ? <Link to={to} className={cls} data-testid={testId} aria-label={name}>{inner}</Link> : <div className={cls} data-testid={testId} aria-label={name}>{inner}</div>;
}

// Sidebar brand: the tenant's uploaded logo + name when present, otherwise the Orbis wordmark.
export function TenantBrand({ me, api, testId = "sidebar-logo" }) {
  const fileId = me?.tenant?.logo_file_id;
  const [url, setUrl] = React.useState(null);
  React.useEffect(() => {
    if (!fileId) { setUrl(null); return; }
    let u;
    api.get(`/tenant/files/${fileId}/download`, { responseType: "blob" }).then((r) => { u = URL.createObjectURL(r.data); setUrl(u); }).catch(() => setUrl(null));
    return () => u && URL.revokeObjectURL(u);
  }, [fileId, api]);
  if (!fileId || !url) return <BrandLogo tone="app" size="sm" testId={testId} />;
  return <BrandLogo name={me?.tenant?.name || "Orbis ERP"} logoUrl={url} size="sm" testId={testId} className="max-w-full overflow-hidden" />;
}
